import api from '@/utils/api';

/**
 * Get all users
 * @returns {Promise}
 */
const getPermissionsApi = () => api.get('conf/permissions');

export default getPermissionsApi;
